import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { TerminosCondiciones } from './pages/TerminosCondiciones';
import { PoliticaPrivacidad } from './pages/PoliticaPrivacidad';
export const AppRouter = () => {
  return <Router data-id="element-15">
      <Routes data-id="element-16">
        <Route path="/" element={<App data-id="element-18" />} data-id="element-17" />
        <Route path="/terminos" element={<TerminosCondiciones data-id="element-20" />} data-id="element-19" />
        <Route path="/privacidad" element={<PoliticaPrivacidad data-id="element-22" />} data-id="element-21" />
      </Routes>
    </Router>;
};